import { getConstant } from "config/chains";
import { getContract } from "config/contracts";
import Reader from "abis/Reader.json";
import { useMinExecutionFee } from "domain/legacy";
import { getTokens, getWhitelistedTokens } from "config/tokens";
import { getUsd, useInfoTokens } from "domain/tokens";
import { useChainId } from "lib/chains";
import useSWR from "swr";
import { contractFetcher } from "lib/contracts";
import { useWeb3React } from "@web3-react/core";

export const useExecutionFee = ({ isMarketOrder }: { isMarketOrder: boolean }) => {
  const { active, account, library } = useWeb3React();
  const { chainId } = useChainId();
  const vaultAddress = getContract(chainId, "Vault");
  const readerAddress = getContract(chainId, "Reader");
  const nativeTokenAddress = getContract(chainId, "NATIVE_TOKEN");
  const tokens = getTokens(chainId);
  const tokenAddresses = tokens.map((token) => token.address);

  const { data: tokenBalances } = useSWR<any>(
    active && [active, chainId, readerAddress, "getTokenBalances", account],
    contractFetcher(library, Reader, [tokenAddresses])
  );

  const whitelistedTokens = getWhitelistedTokens(chainId);
  const whitelistedTokenAddresses = whitelistedTokens.map((token) => token.address);

  const { data: fundingRateInfo } = useSWR<any>(
    [active, chainId, readerAddress, "getFundingRates"],
    contractFetcher(library, Reader, [vaultAddress, nativeTokenAddress, whitelistedTokenAddresses])
  );

  const { infoTokens } = useInfoTokens(library, chainId, active, tokenBalances, fundingRateInfo);

  const { minExecutionFee, minExecutionFeeUSD, minExecutionFeeErrorMessage } = useMinExecutionFee(
    library,
    active,
    chainId,
    infoTokens
  );

  const INCREASE_ORDER_EXECUTION_GAS_FEE = getConstant(chainId, "INCREASE_ORDER_EXECUTION_GAS_FEE");

  const executionFee = INCREASE_ORDER_EXECUTION_GAS_FEE;
  const executionFeeUsd = getUsd(executionFee, nativeTokenAddress, false, infoTokens);

  const currentExecutionFee = isMarketOrder ? minExecutionFee : executionFee;
  const currentExecutionFeeUsd = isMarketOrder ? minExecutionFeeUSD : executionFeeUsd;

  return {
    minExecutionFee,
    minExecutionFeeUSD,
    minExecutionFeeErrorMessage,
    executionFee,
    executionFeeUsd,
    currentExecutionFee,
    currentExecutionFeeUsd,
  };
};
